import React from "react";

export const ManageEstablishmentContext = React.createContext({
    doEdit: null,
    doDelete: null,
});